import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { CommissionsRepository } from '@app/domain/ports/tpv/commissions.repository';
import {
  CompanyCommissionsMatrix,
  CommissionsReadDto,
  MerchantCommissionsMarkup,
  UnitCommissionsMarkup,
} from '@app/data/dtos/tpv/commissions.dto';

/**
 * Mock del CRUD de comisiones para pruebas sin backend (toggle tpvUseMocks).
 * Los GET devuelven null (sin matriz) para ejercitar el camino "crear".
 */
@Injectable()
export class CommissionsMockDataSource extends CommissionsRepository {
  getCompanyCommissions(_idCompany: string): Observable<CommissionsReadDto | null> {
    return of(null).pipe(delay(250));
  }
  createCompanyCommissions(_idCompany: string, _body: CompanyCommissionsMatrix): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
  updateCompanyCommissions(_idCompany: string, _body: Partial<CompanyCommissionsMatrix>): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
  deleteCompanyCommissions(_idCompany: string): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
  getUnitCommissions(_idCompany: string, _idUnit: string): Observable<CommissionsReadDto | null> {
    return of(null).pipe(delay(250));
  }
  updateUnitCommissions(_idCompany: string, _idUnit: string, _body: UnitCommissionsMarkup): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
  getMerchantCommissions(_idMerchant: string): Observable<CommissionsReadDto | null> {
    return of(null).pipe(delay(250));
  }
  updateMerchantCommissions(_idMerchant: string, _body: MerchantCommissionsMarkup): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
}
